import React from "react";
import { vars, styled } from "@puzzle/theme";

import { DATA_TEST_IDS } from "./constants";
import { LogoAndWordmarkContainer } from "./LogoAndWordmarkContainer";
import {
  DarkPuzzleLogo,
  PuzzleWordmark,
  Hamburger,
  MinimizeLeft,
  MinimizeRight,
} from "@puzzle/icons";
import { FeatureFlag, isPosthogFeatureFlagEnabled } from "lib/analytics/featureFlags";

const SlideIn = styled("div", {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  transition: "all 0.15s ease-in-out",
  transform: "translateX(-100%)",
  opacity: "0",

  defaultVariants: {
    minimized: false,
  },
  variants: {
    minimized: {
      false: {
        position: "absolute",
        top: "0",
        left: "0",
        bottom: "0",
      },
      true: {
        width: "40px",
        opacity: "1",
        transform: "translateX(0)",
      },
    },
  },

  // ${(p) =>
  //   !p.minimized &&
  //   css`
  //     position: absolute;
  //     top: 0;
  //     left: 0;
  //     bottom: 0;
  //   `}

  // ${(p) =>
  //   (p.minimized || p.active) &&
  //   css`
  //     width: 40px;
  //     opacity: 1;
  //     transform: translateX(0);
  //   `}
});

const MinimizeButton = styled("button", {
  width: "32px",
  height: "32px",
  border: "none",
  cursor: "pointer",
  borderRadius: "$1",
  outline: "none",
  background: "none",
  color: "$text-neutral-base",

  "&:active, &:hover": {
    backgroundColor: vars.colors["surface-neutral-base"],
    color: "$text-neutral-highlight",
  },
});

const MinimizerWrap = styled("div", {
  height: "50px",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",

  defaultVariants: {
    minimized: false,
  },
  variants: {
    minimized: {
      true: {
        width: "40px",
        [`& ${MinimizeButton}`]: {
          width: "100%",
        },
      },
    },
  },
});

export const Minimizer = ({
  minimized,
  onToggle,
  hovered,
  ...props
}: {
  minimized: boolean;
  onToggle: (minimize: boolean) => void;
  hovered: boolean;
}) => {
  const partialMinimizedEnabled = isPosthogFeatureFlagEnabled(FeatureFlag.SidebarPartialMinimized);

  if (partialMinimizedEnabled) {
    return (
      <MinimizerWrap {...props} data-testid={DATA_TEST_IDS.MINIMIZER}>
        <MinimizeButton onClick={() => onToggle(!minimized)}>
          {minimized ? <MinimizeRight /> : <MinimizeLeft />}
        </MinimizeButton>
      </MinimizerWrap>
    );
  }

  return (
    <MinimizerWrap {...props} data-testid={DATA_TEST_IDS.MINIMIZER}>
      <SlideIn minimized={minimized || hovered}>
        <MinimizeButton onClick={() => onToggle(!minimized)}>
          {minimized && (hovered ? <MinimizeRight /> : <Hamburger />)}
          {!minimized && <MinimizeLeft />}
        </MinimizeButton>
      </SlideIn>

      {!minimized && (
        <LogoAndWordmarkContainer showWordmark={!hovered} data-testid={DATA_TEST_IDS.LOGO}>
          <DarkPuzzleLogo />
          <PuzzleWordmark />
        </LogoAndWordmarkContainer>
      )}
    </MinimizerWrap>
  );
};
